import { Divider, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import getItemCategory from "../../../api/auth/itemCategories/getItemCategory";
import { useParams } from "react-router-dom";
import PageLoading from "../../../components/layout/PageLoading";
import BookableDurations from "../../../components/form/itemCategory/BookableDurations";
import ReservationQuestions from "../../../components/form/itemCategory/ReservationQuestions";
import ItemCategoryName from "../../../components/text/ItemCategoryName";
import useItemStore from "../../../stores/useItemStore";
import ItemTable from "../../../components/displays/items/ItemTable";

export default function ItemCategory() {
  const [itemCategory, setItemCategory] = useState();

  const { itemsByCategoryId } = useItemStore();

  const { id } = useParams();

  useEffect(() => {
    getItemCategory(id, (response) => {
      setItemCategory(response);
    });
  }, []);

  if(!itemCategory) return <PageLoading />;

  const items = itemsByCategoryId(itemCategory.id);

  return (
    <Stack>
      <Stack mb={4}>
        <ItemCategoryName itemCategory={itemCategory} variant="h4" />
        <Typography variant="body1">{itemCategory.description}</Typography>
      </Stack>
      <Stack>
        <Stack mb={2}>
          <Typography variant="h5">Items</Typography>
        </Stack>
        <ItemTable items={items} />
      </Stack>
      <Divider sx={{ my: 4 }}/>
      <Stack>
        <BookableDurations itemCategory={itemCategory} />
      </Stack>
      <Divider sx={{ my: 4 }}/>
      <Stack>
        <ReservationQuestions itemCategory={itemCategory} />
      </Stack>
    </Stack>
  );
}